import {
  getSiteContributorsV2 as publicGetSiteContributorsV2,
  changeRole as publicChangeRole,
  changeContributorLocation as publicChangeContributorLocation,
  querySiteContributors as publicQuerySiteContributors,
  getContributorsQuota as publicGetContributorsQuota,
  removeContributor as publicRemoveContributor,
} from './identity-v1-contributor-contributors.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onContributorCreated as publicOnContributorCreated } from './identity-v1-contributor-contributors.public.js';

/** @internal */
export const getSiteContributorsV2: MaybeContext<
  BuildRESTFunction<typeof publicGetSiteContributorsV2> &
    typeof publicGetSiteContributorsV2
> = /*#__PURE__*/ createRESTModule(publicGetSiteContributorsV2);
export const changeRole: MaybeContext<
  BuildRESTFunction<typeof publicChangeRole> & typeof publicChangeRole
> = /*#__PURE__*/ createRESTModule(publicChangeRole);
export const changeContributorLocation: MaybeContext<
  BuildRESTFunction<typeof publicChangeContributorLocation> &
    typeof publicChangeContributorLocation
> = /*#__PURE__*/ createRESTModule(publicChangeContributorLocation);
export const querySiteContributors: MaybeContext<
  BuildRESTFunction<typeof publicQuerySiteContributors> &
    typeof publicQuerySiteContributors
> = /*#__PURE__*/ createRESTModule(publicQuerySiteContributors);
/** @internal */
export const getContributorsQuota: MaybeContext<
  BuildRESTFunction<typeof publicGetContributorsQuota> &
    typeof publicGetContributorsQuota
> = /*#__PURE__*/ createRESTModule(publicGetContributorsQuota);
export const removeContributor: MaybeContext<
  BuildRESTFunction<typeof publicRemoveContributor> &
    typeof publicRemoveContributor
> = /*#__PURE__*/ createRESTModule(publicRemoveContributor);
/** */
export const onContributorCreated: BuildEventDefinition<
  typeof publicOnContributorCreated
> &
  typeof publicOnContributorCreated = createEventModule(
  publicOnContributorCreated
);

export {
  ResourceType,
  ConditionAttributeType,
  SubjectType,
  SubjectContextType,
  InviteStatus,
  Type,
  FieldSet,
  WebhookIdentityType,
} from './identity-v1-contributor-contributors.universal.js';
export {
  Contributor,
  PersonMetaData,
  Assignment,
  AssignedPolicy,
  Restriction,
  RestrictionRestrictionsOneOf,
  Resource,
  Conditions,
  Condition,
  SiteRestriction,
  CompanionResource,
  LocationsRestriction,
  Subject,
  SubjectContext,
  GetSiteContributorsRequest,
  GetSiteContributorsResponse,
  User,
  Name,
  Team,
  ApiAccountInfo,
  SiteInvite,
  Policy,
  PendingOwner,
  ContributorLimit,
  PredefinedRoles,
  PredefinedRole,
  Role,
  GetSiteContributorsV2Request,
  GetSiteContributorsV2Response,
  ContributorsQuota,
  ContributorsQuotaOptionsOneOf,
  LimitedOptions,
  EnrichedSiteInvite,
  LocalizedPolicyInfo,
  HandleSiteTransferRequest,
  HandleSiteTransferResponse,
  GetCurrentUserRolesRequest,
  GetCurrentUserRolesResponse,
  LocalizedRole,
  BulkGetUserRolesOnSiteRequest,
  UserSubject,
  BulkGetUserRolesOnSiteResponse,
  UserLocalizedRoles,
  BulkValidateEmailInviteEligibilityRequest,
  BulkValidateEmailInviteEligibilityResponse,
  EmailInviteEligibility,
  ChangeContributorRoleRequest,
  SiteRoleAssignment,
  ChangeContributorRoleResponse,
  ChangeContributorLocationRequest,
  ChangeContributorLocationResponse,
  SiteLocationAssignment,
  QuerySiteContributorsRequest,
  QuerySiteContributorsFilter,
  QuerySiteContributorsResponse,
  ContributorV2,
  GetContributorsQuotaRequest,
  GetContributorsQuotaResponse,
  RemoveContributorRequest,
  RemoveContributorResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetAppContributorsRequest,
  GetAppContributorsResponse,
  AppInvite,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ContributorCreatedEnvelope,
  GetSiteContributorsV2Options,
  ChangeRoleOptions,
  ChangeContributorLocationOptions,
  QuerySiteContributorsOptions,
} from './identity-v1-contributor-contributors.universal.js';
export {
  ResourceTypeWithLiterals,
  ConditionAttributeTypeWithLiterals,
  SubjectTypeWithLiterals,
  SubjectContextTypeWithLiterals,
  InviteStatusWithLiterals,
  TypeWithLiterals,
  FieldSetWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './identity-v1-contributor-contributors.universal.js';
